import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';

// Initialize OktaAuth with your configuration
 const oktaConfig = {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID || "",
    issuer: process.env.REACT_APP_OKTA_ISSUER || "",
    redirectUri: `${window.location.origin}/login/callback`,
    // redirectUri: '/rtbf_approvals',
    logoutUrl: process.env.REACT_APP_OKTA_LOGOUT_URL || "",
    scopes: ['openid', 'profile', 'email'],
    pkce: process.env.REACT_APP_OKTA_PKCE === "true" || false,
};



export default oktaConfig;